<template>
  <div class="carousel">
    <div class="carousel-track" ref="track">
      <div class="slide" v-for="(image, index) in images" :key="index">
        <a :href="image.destUrl" @click="!image.destUrl && $event.preventDefault()" target="_blank">
          <img :src="image.content" />
        </a>
      </div>
    </div>

    <div class="dots">
      <span
        class="dot"
        v-if="slideSteps > 0"
        v-for="(_, i) in slideSteps"
        :key="i"
        :class="{ active: i === currentIndex }"
        @click="goToSlide(i)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      currentIndex: 0,
      intervalId: null,
      visibleSlides: 4
    }
  },

  computed: {
    slideSteps () {
      return Math.max(this.images.length - this.visibleSlides + 1, 0)
    }
  },

  mounted () {
    if (this.slideSteps > 0) {
      this.setResponsiveSlides()
      window.addEventListener('resize', this.setResponsiveSlides)
      this.startAutoSlide()
    }
  },

  beforeUnmount () {
    clearInterval(this.intervalId)
    window.removeEventListener('resize', this.setResponsiveSlides)
  },

  methods: {
    startAutoSlide () {
      this.intervalId = setInterval(() => {
        this.nextSlide()
      }, 3000)
    },

    nextSlide () {
      this.currentIndex = (this.currentIndex + 1) % this.slideSteps
      this.updateTransform()
    },

    goToSlide (index) {
      clearInterval(this.intervalId)
      this.currentIndex = index
      this.updateTransform()
      this.startAutoSlide()
    },

    updateTransform () {
      const shift = (100 / this.visibleSlides) * this.currentIndex
      this.$refs.track.style.transform = `translateX(-${shift}%)`
    },

    setResponsiveSlides () {
      const width = window.innerWidth
      if (width > 1440) {
        this.visibleSlides = 4
      } else if (width > 1024) {
        this.visibleSlides = 3
      } else if (width >= 768) {
        this.visibleSlides = 2
      } else {
        this.visibleSlides = 1
      }
      this.currentIndex = 0
      this.updateTransform()
    }
  },

  beforeDestroy () {
    clearInterval(this.intervalId)
    window.removeEventListener('resize', this.setResponsiveSlides)
  }
}
</script>

<style scoped>
.carousel {
  overflow: hidden;
  margin: 0 auto;
  position: relative;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease;
}

.slide {
  flex: 0 0 calc(100% / 4);
  padding: 12px;
}

.slide img {
  width: 100%;
  /* height: 150px; */
}

.dots {
  text-align: center;
  margin-top: 12px;
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 4px;
  background-color: #ccc;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dot.active {
  background-color: #333;
}

@media (max-width: 1440px) {
  .slide {
    flex: 0 0 calc(100% / 3);
  }
}

@media (max-width: 1024px) {
  .slide {
    flex: 0 0 calc(100% / 2);
  }
}

@media (max-width: 767px) {
  .slide {
    flex: 0 0 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Slider.vue